import PubSub from "services/PubSub";
import StorageService from 'services/StorageService';
import CmsService from "services/CMS/";
import { slugify, cleanSearch, getLinkCategory, cleanFacet } from 'utils'
import ProductService from "services/Product/";
import SalesChannel from 'services/SalesChannel';
import queryString from 'query-string';
import { api } from 'config';
import { ecommerce, consumer } from 'config/constants';
import ProductFactory from "factories/Products";
import { features } from "config";

let categories = [];
let category = null;
let filters = null;
let specifications = [];
let _categoriesParams = null;
let _filterService = null;
let filterByBrand = false;
let searchTerm = null;
let urlDecode = '';

const getFilters = (filterService, categoriesParams, location) => {
    const { pathname, search } = location;

    _categoriesParams = categoriesParams;
    _filterService = filterService

    return _getFilters(pathname, search)
}

const _getFilters = (pathname, searchData) => {

    return Promise.all([ProductService.getFilters(pathname + validateParams(searchData)), getcmsCategories()]).then(results => {
        const cmsCats = results[1];
        const resultsFilter = results[0];

        filterByBrand = resultsFilter.filterByBrand;

        const { search } = _filterService;

        if (!search) {
            StorageService.removeItem('attemptsSearch');
        }

        const vtexCats = resultsFilter && resultsFilter.CategoriesTrees ? resultsFilter.CategoriesTrees : [];
        
        urlDecode = resultsFilter['url-decode'];


        let newPathname = pathname;
        let newSearch = searchData;
        let newTitle = '';

        if (urlDecode) {
            const urlSplit = urlDecode.split('?');
            newPathname = urlSplit.length ? urlSplit[0] : pathname;
            newSearch = urlSplit.length > 1 ? urlSplit[1] : searchData;
            if(resultsFilter.metaTitle) newTitle = resultsFilter.metaTitle

            
        }

        const categoriesFiltered = _filterCategories(cmsCats, vtexCats, (filterByBrand ? resultsFilter.Brands : []), urlDecode ? newSearch : '');

        if (!filterByBrand && !resultsFilter.notFound && !urlDecode) {
            _applyCategories(categoriesFiltered);
        }else{
            categories = []
        }

        if (search && !(resultsFilter && resultsFilter.Departments && resultsFilter.Departments[0])) {
            searchTerm = search + '';
            _dispatchRedirect(`/busqueda${newPathname}?ft=${searchTerm}`, true);
        }

        if (filterByBrand) {
            const countPath = pathname.split('/').length - 1;
            if (resultsFilter.Brands.length > countPath) {
                redirectError404(search);
                return false;
            }
        }

        filters = {
            categories: categoriesFiltered,
            brands: resultsFilter.Brands,
            filters: resultsFilter.SpecificationFilters
        };
        let promise = Promise.resolve(false);
        
        if (resultsFilter.notFound) {
            redirectError404(search);
        } else {
            promise = init(resultsFilter?.typeDecode === 'brand');
        }

        return promise.then(() => {
            _filterService.specifications.forEach((item) => {
                let _specification = specifications.filter(_item => _item.FieldId === parseInt(item.id));
                if(_specification.length){
                    _specification= _specification[0];
                    if(filters.filters[_specification.Name]){
                        filters.filters[_specification.Name] = filters.filters[_specification.Name].map((_filter) => {
                            if(_filter.Value === item.slug){
                                _filter.active = true;
                                _filter.id = item.id;
                            }
                            return _filter
                        })
                    }
                }
            })

            return {
                filters,
                filterByBrand,
                searchTerm,
                categories,
                specifications,
                category,
                pathname: newPathname,
                search: newSearch,
                title: newTitle

            }

        })
    }).catch(() => {
        filterByBrand = false;
        filters = null;
        categories = [];
        specifications = [];
        category = null;
        searchTerm = '';
    });
};

const _applyCategories = (results) => {
    categories = getCategories(0, results);

    categories = categories.map((categoryData) => {
        let link = null;

        if (typeof categoryData !== 'string') {
            link = { ...categoryData };
            link.url = getLinkCategory(link.url);
        }

        return link ? link : categoryData;
    });

    category = categories.slice(-1).pop();
}

const getcmsCategories = () => {
    if (!(window && window.location)) return false;
    return CmsService.getMenu(false).then(data => {
        return JSON.parse(JSON.stringify(data.acf.items));
    });
}

const _filterCategories = (cmsCats, vtexCats, brands = [], qryParams = '') => {
    const categoriesData = cmsCats.map(categoryData => {

        const indexCat = vtexCats.findIndex(cat => {
            return clearURL(cat.Link.split('?')[0].toLowerCase()).indexOf(clearURL(categoryData.url)) !== -1
        });

        if (indexCat !== -1) {
            if (categoryData.items) {
                categoryData.items = _filterCategories(categoryData.items, vtexCats[indexCat].Children, brands, qryParams);
            }

            const brandsPath = brands.length ? '/' + brands.map(item => slugify(item.Name)).join('/') : '';

            categoryData.id = vtexCats[indexCat].Id;

            if (filterByBrand || qryParams) {
                categoryData.url = categoryData.url + brandsPath + ( qryParams ? '?' + qryParams : '');
            }

            return categoryData

        } else {
            return false
        }

    }).filter(Boolean);

    return fixCategories(categoriesData);
}

const validateParams = (search) => {
    if (search) {
        let params = queryString.parse(search);

        if (params.ft) {
            params.ft = cleanSearch(params.ft);
        }

        search = '?' + queryString.stringify(params);
    }

    return search;
}

const getCategories = (index, categoriesData) => {
    let currentCategories = [];
    const categoryName = Array.isArray(_categoriesParams) && _categoriesParams[index] ? '/' + _categoriesParams.slice(0, index + 1).join('/') : '';
    for (let i = 0; i < categoriesData.length; i++) {
        const categoryData = categoriesData[i];
        if (clearURL(categoryData.url.split('?')[0]) === clearURL(categoryName)) {
            currentCategories = currentCategories.concat(categoryData);
            if (_categoriesParams[index + 1]) {
                const children = getCategories(index + 1, categoryData.items);
                if (children) {
                    currentCategories = currentCategories.concat(children);
                }
            }
        }
    }
    return (currentCategories.length) ? currentCategories : [];
}

const clearURL = (url) => {
    return url.replace('---', '-').replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i").replace(/ó/g, "o").replace(/ú/g, "u").replace(/ñ/g, "n");
}

const redirectError404 = (search = null) => {
    search = search ? `?ft=${search}` : '';
    _dispatchRedirect(`/Sistema/busquedavacia${search}`);

}

const _dispatchRedirect = (url, replace = false) => {
    PubSub.dispatch('catalog_url_redirect', {
        url,
        replace
    });
}


const fixCategories = (categoriesData, withParams = true) => {
    const params = window.location.search;

    return categoriesData ? categoriesData.map((itemCategory) => {
        const _url = (withParams && itemCategory.url.indexOf(params.replace('?','')) === -1) ? itemCategory.url + (params) : itemCategory.url 

        return {
            id: itemCategory.id,
            items: itemCategory.items ? fixCategories(itemCategory.items, false) : [],
            name: itemCategory.name || itemCategory.title,
            url: _url
        }
    }) : [];
}

const applyInitialFilters = () => {
    const { brands } = _filterService;
    const specificationsData = _filterService.specifications;
    brands.map((brand) => {
        filters.brands
            .map((item) => item.active = item.active || (cleanFacet(item.Name) === brand));
    });

    specificationsData.map(specification => {
        Object.keys(filters.filters).forEach( item => {
            filters.filters[item] = filters.filters[item].map((itemFilter) => {
                itemFilter.id = itemFilter.key.replace('-', ' ').toLowerCase();
                itemFilter.active = itemFilter.active || (itemFilter.key.replace('-', ' ').toLowerCase() === specification.id.toLowerCase() && itemFilter.Name === specification.slug)
                return itemFilter
            })
        })
    });
}

const init = (decodeBrand = false) => {
    if (_filterService.search === '' && _filterService.collections === '') {
        if (category) {
            if(!decodeBrand) filters.categories = [category];
            applyInitialFilters();
        } else if (filterByBrand || urlDecode) {
            applyInitialFilters();
        }
        return Promise.resolve(false);
    } else {
        applyInitialFilters();
        return Promise.resolve(false);
    }
}

const getRecommended = (numberResults, sku = false, campaingName = false, filter = false,  type = false, categoryId = false, filterValues) => {

    const sc = SalesChannel.getSalesChannel();
    let token = StorageService.getItem('sessionData');
    let params = '';
    let url = '';

    const segmentID = StorageService.getSecureItem('segmentID');
    let headers = {
        'x-api-key': api.apiKey,
        'token': token,
    }

    if(!token && segmentID){
        headers['x-segment'] = segmentID
        delete headers['token'];
    }

    if(ecommerce.whiteLabel) {
        const sellerSelected = SalesChannel.getSeller();
        headers['x-consumer'] = consumer;
        url = `/${sellerSelected}${url}`;
    }

    params = `${numberResults ? '&numResults=' + numberResults  : ''}${sku ? '&itemId=' + sku : ''}${campaingName ? '&campaign=' + campaingName : ''}${filter ? `&filter=` + filter : ''}${type && categoryId ? `&filterValues=${type}:${categoryId}` : ''}${filterValues ? filterValues : ''}`;
    return fetch(api.catalog + url +`/products/recommended?sc=${sc}${params ? params : ''}`, {
        headers
    }).then(results => results.json())
        .then((results) => {
            results = results.map((product) => ProductFactory.create(product))
            return results;
        })
        .catch(() => {
            return [];
        });
}

const getOrderRanking = (ids) => {
    let token = StorageService.getItem('sessionData');
    if(!ids) return Promise.resolve(null);
    const segmentID = StorageService.getSecureItem('segmentID');
    let headers = {
        'x-api-key': api.apiKey,
        'token': token,
    }

    if(!token && segmentID){
        headers['x-segment'] = segmentID
        delete headers['token'];
    }
    return fetch(api.catalogV2 + `/ranking/skus?skus=${ids}${(ecommerce.whiteLabel && features.personalize) ? '&campaign=ranking-sisa' : ''}`, {
        headers
    }).then(results => results.json())
        .then((results) => {
            return results;
        })
        .catch(() => {
            return [];
        });
}

const CatalogService = {
    getFilters,
    getRecommended,
    getOrderRanking
}

export default CatalogService;
